import { reactive, toRefs } from 'vue'
import { cloneDeep } from 'lodash-es'

export const useState = (initialState) => {
  if (initialState.$reset !== undefined) {
    throw new Error('$reset key is reserved')
  }

  const state = toRefs(reactive(cloneDeep(initialState)))

  const $reset = () => {
    for (const key of Object.keys(state)) {
      state[key].value = cloneDeep(initialState[key])
    }
  }

  return { ...state, $reset }
}
